import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import { useSelector } from 'react-redux';
import * as NotificationService from 'services/api/notification';

interface RegistrationReceivedListElement {
  registration_received_id: number;
  msid_country: string;
  message_id: string;
  message_timestamp: string;
  application_type: string;
  vat_number: string;
  company_name: string;
  change_date: string;
  address_free: string;
  address_country: string;
  telephone: string;
  email: string;
  websites: string;
  contact_title: string;
  contact_first_name: string;
  contact_last_name: string;
  trading_names: string;
  country_of_business: string;
  vat_group: number;
  bank_iban: string;
  bank_account: string;
  bank_bic: string;
  request_date: string;
  commencement_date: string;
  registration_date: string;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
  incoming_message_id: number;
}

interface RegistrationReceivedListPaging {
  page: number;
  pageSize: number;
  total: number;
}

interface RegistrationReceivedListData {
  paging: RegistrationReceivedListPaging;
  items: RegistrationReceivedListElement[];
}

interface RegistrationReceivedistOutput {
  status: StateStatus;
  data: RegistrationReceivedListData | null;
}

export const useGetRegistrationReceivedList =
  (): RegistrationReceivedistOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.REGISTRATION_RECEIVED_REDUCER]
          .RegistrationReceivedList
    );
    return data;
  };

/* selector: useGetRegistrationReceivedDetails */
interface RegistrationReceivedDetailsData {
  registration_received_id: number;
  msid_country: string;
  message_id: string;
  message_timestamp: string;
  application_type: string;
  vat_number: string;
  company_name: string;
  change_date: string;
  address_free: string;
  address_country: string;
  telephone: string;
  email: string;
  websites: string;
  contact_title: string;
  contact_first_name: string;
  contact_last_name: string;
  trading_names: string;
  country_of_business: string;
  vat_group: number;
  bank_iban: string;
  bank_account: string;
  bank_bic: string;
  request_date: string;
  commencement_date: string;
  registration_date: string;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
  incoming_message_id: number;
  exclusion_code: number;
  exclusion_decision_date: string;
  exclusion_effective_date: string;
  importation_effective_date: string;
}

interface RegistrationReceivedDetailsOutput {
  status: StateStatus;
  data: RegistrationReceivedDetailsData | null;
}

export const useGetRegistrationReceivedDetails =
  (): RegistrationReceivedDetailsOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.REGISTRATION_RECEIVED_REDUCER]
          .viewRegistrationReceived
    );
    return data;
  };

// FIXED ESTABLISHMENT RECEIVED BY REGISTRATION RECEIVED ID
interface FixedEstablishmentReceivedListElement {
  fixed_establishment_received_id: number;
  registration_received_id: number;
  fe_country: string;
  fe_vat_number: string;
  fe_trading_name: string;
  fe_address: string;
  fe_address_country: string;
}

interface FixedEstablishmentReceivedListData {
  paging: FixedEstablishmentReceivedListPaging;
  items: FixedEstablishmentReceivedListElement[];
}

interface FixedEstablishmentReceivedListPaging {
  page: number;
  pageSize: number;
  total: number;
}

interface FixedEstablishmentReceivedistOutput {
  status: StateStatus;
  data: FixedEstablishmentReceivedListData | null;
}

export const useGetFEReceivedByRegisrationReceivedIdList =
  (): FixedEstablishmentReceivedistOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.REGISTRATION_RECEIVED_REDUCER]
          .FixedEstablishmentReceivedList
    );
    return data;
  };

interface ICountry {
  country_id: number;
  code: string;
  description: string;
  numeric_code: number;
}

export const useGetUnreadNotificationCount = (): number => {
  const data = useShallowEqualSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_RECEIVED_REDUCER].unreadNotificationCount
        .data
  );
  return data;
};

export const useGetMemberStateExcludeCyprusCountries = (): Array<ICountry> => {
  const data = useSelector(
    (state: any) =>
      state[ReducerKeys.REGISTRATION_RECEIVED_REDUCER]
        .memberStateExcludeCyprusList.data
  );
  return data;
};
